<template>
    <div class="loader">
        <div class="loader-center">
            <div class="spinner-border swif-blue-color" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "loader"
}
</script>>